var map = {
	"./gallery-1.jpg": 5965,
	"./gallery-2.jpg": 3177,
	"./gallery-3.jpg": 3079,
	"./gallery-4.jpg": 6800,
	"./gallery-bg.png": 8479,
	"./gallery-five-1.jpg": 8004,
	"./gallery-five-2.jpg": 4489,
	"./gallery-five-3.jpg": 1239,
	"./gallery-five-4.jpg": 2035,
	"./gallery-four-1.jpg": 1370,
	"./gallery-four-2.jpg": 1138,
	"./gallery-four-3.jpg": 6477,
	"./gallery-four-4.jpg": 9865,
	"./gallery-four-5.jpg": 9122,
	"./gallery-four-6.jpg": 9524,
	"./gallery-four-7.jpg": 4527,
	"./gallery-four-8.jpg": 8622,
	"./gallery-three-1.jpg": 9514,
	"./gallery-three-2.jpg": 1417,
	"./gallery-three-3.jpg": 1007,
	"./gallery-three-4.jpg": 9715,
	"./gallery-three-5.jpg": 2809,
	"./gallery-three-6.jpg": 7683,
	"./gallery-three-7.jpg": 5412,
	"./gallery-three-8.jpg": 6266,
	"./gallery-three-9.jpg": 7431,
	"./gallery-two-1.jpg": 6602,
	"./gallery-two-2.jpg": 5797,
	"./gallery-two-3.jpg": 869,
	"./portfolio-details.jpg": 6792,
	"./portfolio-middle-1.jpg": 6179,
	"./portfolio-middle-2.jpg": 3080,
	"./project1.jpg": 7083,
	"./project2.jpg": 9399,
	"./project3.jpg": 9132,
	"./project4.jpg": 9097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8379;